import { render, staticRenderFns } from "./TalkToVisitorSetting.vue?vue&type=template&id=43977d58&"
import script from "./TalkToVisitorSetting.vue?vue&type=script&lang=js&"
export * from "./TalkToVisitorSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports